import { firestore } from 'firebase';

import DatabaseAdapter from 'src/firebase/db/DatabaseAdapter';
import { ReferenceError, InternalError } from 'src/firebase/db/ApplicationError';

/**
 * name: string | 商品名
 * price: number | 価格
 * quantity: number | 数量
 * image: string | 画像URL
 * order_id: string | orders.id
 * order_breads_ref: refference | 配信されたパンへのref
 */

export const orderItemInitialEntity = {
  name: '',
  image: '',
  order_breads_ref: {} as firestore.DocumentReference,
  order_id: '',
  price: 0,
  quantity: 0,
};
export type OrderItemEntity = typeof orderItemInitialEntity;
export const orderItemEntityKeys = (Object.keys(
  orderItemInitialEntity,
) as unknown) as (keyof OrderItemEntity)[];

export const orderItemRevenueIntialEntity = {
  totalAmount: 0,
  totalCount: 0,
  item: [] as OrderItemEntity[],
};

export type OrderRevenueEntity = typeof orderItemRevenueIntialEntity;

class OrderItemsDB extends DatabaseAdapter {
  constructor(props: any) {
    super(props);
    this.setSchemaKeys(orderItemEntityKeys);
  }

  getOrderItems = async (orderId: string) => {
    const ordersRef = this.getConnection('orders').doc(orderId);
    const docRef = this.getConnection()
      .orderBy('created_at', 'asc')
      .where('orders_ref', '==', ordersRef);
    return docRef
      .get()
      .then((snapshot) => {
        if (snapshot.empty) {
          throw new ReferenceError('注文明細が存在しません');
        } else {
          const orders = snapshot.docs.map((doc) => {
            return doc.data() as OrderItemEntity;
          });
          return this.formatSuccess<OrderItemEntity[]>(orders);
        }
      })
      .catch((err) => {
        console.log(err);
        if (err instanceof ReferenceError) {
          throw err;
        }
        throw new InternalError(err.message);
      });
  };

  // デバッグ用のダミーデータを作成
  async create(query: Partial<OrderItemEntity>) {
    const filteredQuery = this.filterQuery(query);

    const requestQuery = {
      ...filteredQuery,
      created_at: this.getServerTimeStamp(),
      updated_at: this.getServerTimeStamp(),
    };

    const ref = this.getConnection();
    return ref
      .add(requestQuery)
      .then(async (orderItemDocRef) => {
        const orderItemId = orderItemDocRef.id;

        // 更新後のデータ取得
        await orderItemDocRef.update({ id: orderItemId });

        return orderItemDocRef;
      })
      .catch((err) => {
        console.error(err);
        throw new InternalError(err.message);
      });
  }
}

export default new OrderItemsDB({
  schema: 'order_items',
});
